import { useDropboxSource } from '@/modules/upload/cloud/dropbox/useDropboxSource'
import {
  CloudImportButton,
  type ProviderImportButtonProps,
} from './CloudImportButton'
import { DropboxIcon } from './ProviderIcons'

export const DropboxImportButton = (props: ProviderImportButtonProps) => {
  const source = useDropboxSource()
  if (!source) return null
  return <CloudImportButton source={source} icon={<DropboxIcon />} {...props} />
}
